import { useCallback } from "react";
import { useMap } from "maplibre-react-components";
import type { Map as MapLibreMap } from "maplibre-gl";

interface ZoomOptions {
  step?: number;
  duration?: number;
  easing?: (t: number) => number;
}

export function useZoom() {
  const map = useMap() as MapLibreMap | null;

  const zoom = useCallback(
    (delta: number, opts: ZoomOptions = {}) => {
      if (!map) return;
      const { step = 1, duration = 500, easing = (t) => t } = opts;
      const target = map.getZoom() + delta * step;
      map.easeTo({ zoom: target, duration, easing });
    },
    [map]
  );

  const zoomIn = useCallback((opts?: ZoomOptions) => zoom(+1, opts), [zoom]);
  const zoomOut = useCallback((opts?: ZoomOptions) => zoom(-1, opts), [zoom]);

  return { zoomIn, zoomOut };
}
